export default {
  sm: `
  데이터센터 각이 안전하게 저장하고
  관리한 일상의 가치와 문화적 정체성은,
  미래의 후손들이 현재의 삶을 이해하는
  근거가 될 것입니다.
  `,
  md: `
  데이터센터 각이 안전하게 저장하고 관리한
  일상의 가치와 문화적 정체성은,
  미래의 후손들이 현재의 삶을 이해하는
  근거가 될 것입니다.
  `,
  lg: `
  데이터센터 각이 안전하게 저장하고 관리한 일상의 가치와
  문화적 정체성은, 미래의 후손들이 현재의 삶을 이해하는
  근거가 될 것입니다.
  `,
  xxl: `
  데이터센터 각이 안전하게 저장하고 관리한 일상의 가치와 문화적
  정체성은, 미래의 후손들이 현재의 삶을 이해하는 근거가 될 것입니다.
  `
};
